import { SVGIconComponent } from '../types';

export const thunderstorm: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 15 16" {...props}>
    <title>{title}</title>
    <path d="M11.447 4.013A4.012 4.012 0 0 0 7.5.667c-1.453 0-2.78.786-3.48 2.04A3.678 3.678 0 0 0 .833 6.333 3.673 3.673 0 0 0 4.5 10h6.667a3 3 0 0 0 .28-5.987ZM9.367 10.667 7.433 12.88l1.334.667L7.2 15.333h1.767L10.9 13.12l-1.333-.667 1.566-1.786H9.367ZM5.367 10.667 3.433 12.88l1.334.667L3.2 15.333h1.767L6.9 13.12l-1.333-.667 1.566-1.786H5.367Z" />
  </svg>
);
